import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder,
  SerializedData, mapToData, cloneMap, isSameMap } from '../dto/dto.js';

export class StaffSettings extends DataModel {
  static readonly TYPE_ID: string = 'e7b37a1e52694a88ac1383f404d5d995';

  constructor(
        public readonly staffRoles: Map<string, string>,
        public readonly defaultStaffRole: string | null,
  ) {
    super();
  }

  get $typeId(): string {
    return StaffSettings.TYPE_ID;
  }

  static empty(defaultStaffRole: string | null = null): StaffSettings {
    return new StaffSettings(
        new Map<string, string>(),
        defaultStaffRole ?? null,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): StaffSettings {
    return new StaffSettings(
        MapUtils.getMap(map, 'staffRoles', (k: string, v: unknown) => {
          return {
            key: k as string,
            value: v as string,
          };
        }),
        MapUtils.getOrNull<string>(map, 'defaultStaffRole'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'staffRoles': mapToData(this.staffRoles, (k: string, v: string) => {
        return {
          key: k,
          value: v,
        };
      }),
      'defaultStaffRole': this.defaultStaffRole,
    };
  }

  clone(): this {
    return new StaffSettings(
        cloneMap(this.staffRoles),
        this.defaultStaffRole,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameMap(other.staffRoles, this.staffRoles) &&
        other.defaultStaffRole === this.defaultStaffRole;
  }
}

export class StaffSettingsBuilder extends DataModelBuilder<StaffSettings> {
  build(context: SerializationContext, map: SerializedData): StaffSettings {
    return StaffSettings.fromMap(context, map);
  }
}
